import { render } from "./SegmentosProdView.vue?vue&type=template&id=255fcb06&scoped=true"
import script from "./SegmentosProdView.vue?vue&type=script&lang=js"
export * from "./SegmentosProdView.vue?vue&type=script&lang=js"

import "./SegmentosProdView.vue?vue&type=style&index=0&id=255fcb06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255fcb06"]])

export default __exports__